import type {ManualFnsReceipt} from './types';

export const RECEIPT_ERROR_LABEL = 'Проблемы с чеком';
export const RECEIPT_CHECKING_LABEL = 'Чек на проверке';
export const RECEIPT_CHECKING_STATUS_LABEL = 'Проверяем чек';

export type ManualFnsReceiptFields = {
	requiredSelfemploymentProvider?: string | null;
	manualFnsReceipt?: ManualFnsReceipt | null;
};

export function readManualFnsReceiptFields(task: object): ManualFnsReceiptFields {
	const source = task as ManualFnsReceiptFields;

	return {
		requiredSelfemploymentProvider: source.requiredSelfemploymentProvider,
		manualFnsReceipt: source.manualFnsReceipt,
	};
}

export function isFreeSmzReceiptError(task: object): boolean {
	const {requiredSelfemploymentProvider, manualFnsReceipt} = readManualFnsReceiptFields(task);

	return (
		requiredSelfemploymentProvider === 'free_smz' &&
		manualFnsReceipt?.required === true &&
		manualFnsReceipt.status === 'rejected'
	);
}

export function isFreeSmzReceiptChecking(task: object): boolean {
	const {requiredSelfemploymentProvider, manualFnsReceipt} = readManualFnsReceiptFields(task);

	return (
		requiredSelfemploymentProvider === 'free_smz' &&
		manualFnsReceipt?.required === true &&
		manualFnsReceipt.status === 'checking'
	);
}
